import React, { useState } from 'react';
import { InfinitySpin } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { getbase64 } from '../../../utils/base64Converter';
import {
  CreateReels,
  UploadReelsImage,
} from '../../../redux/admin/reels/reels_services_sync';

const baseSchema = Yup.object({
  title: Yup.string().required(),
  link: Yup.string().required(),
  reelsType: Yup.string().required(),
});

const reelsTypeStatus = [
  { name: 'instagram' },
  { name: 'tiktok' },
  { name: 'pinterest' },
  { name: 'facebook' },
];

const Create_Reels = () => {
  const dispatch = useDispatch();

  const [image, setImage] = useState();

  const { reelsEditLoader, reelsImageDetails, reels_loader } = useSelector(
    (state) => state.reels
  );

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (reels_loader) return;

    const payload = {
      ...value,
      reel_image: reelsImageDetails?.secure_url,
      reel_image_id: reelsImageDetails?.public_id,
    };

    await dispatch(CreateReels({ ...payload }));

    resetForm();

    // router.push('/admin_dashboard/users');
  };

  const handleReelsImage = (e) => {
    if (reelsEditLoader) return;

    const image = e.target.files[0];

    if (image) {
      let promise = getbase64(image);
      promise
        .then((data) => {
          dispatch(UploadReelsImage({ file: data }));
          return data;
        })
        .then((res) => {
          setImage(image?.name);
        });
    }
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      title: '',
      link: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  return (
    <>
      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <div class="card">
            <div class="card-body">
              <div class="bg-light text-center rounded bg-light">
                {reelsImageDetails?.secure_url && (
                  <img
                    src={reelsImageDetails?.secure_url}
                    alt=""
                    class="avatar-xxl"
                  />
                )}
              </div>
              <div class="mt-3">
                <h4>{image ? image : <>Reels pics</>}</h4>
                {/* <div class="row">
                      <div class="col-lg-4 col-4">
                        <p class="mb-1 mt-2">Created By :</p>
                        <h5 class="mb-0">Seller</h5>
                      </div>
                      <div class="col-lg-4 col-4">
                        <p class="mb-1 mt-2">Stock :</p>
                        <h5 class="mb-0">46233</h5>
                      </div>
                      <div class="col-lg-4 col-4">
                        <p class="mb-1 mt-2">ID :</p>
                        <h5 class="mb-0">FS16276</h5>
                      </div>
                    </div> */}
              </div>
            </div>
            <div class="card-footer border-top">
              <div class="row g-2">
                {/* <div class="col-lg-6">
                      <a href="#!" class="btn btn-outline-secondary w-100">
                        Create Reels
                      </a>
                    </div> */}
                <div class="col-lg-6">
                  <a href="#!" class="btn btn-primary w-100">
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Add Thumbnail Photo</h4>
            </div>
            <div class="card-body">
              <form
                action="https://techzaa.in/"
                method="post"
                class="dropzone"
                id="myAwesomeDropzone"
                data-plugin="dropzone"
                data-previews-container="#file-previews"
                data-upload-preview-template="#uploadPreviewTemplate"
                style={{ position: 'relative' }}
              >
                <div class="fallback">
                  <input
                    name="file"
                    type="file"
                    multiple
                    onChange={handleReelsImage}
                    style={{
                      border: '1px solid red',
                      position: 'absolute',
                      width: '98%',
                      height: '90%',
                      opacity: 0,
                    }}
                  />
                </div>
                <div class="dz-message needsclick">
                  <i class="bx bx-cloud-upload fs-48 text-primary"></i>
                  <h3 class="mt-4">
                    Drop your images here, or{' '}
                    <span class="text-primary">click to browse</span>
                  </h3>
                  <span class="text-muted fs-13">
                    {image ? (
                      `${image}`
                    ) : (
                      <>
                        1600 x 1200 (4:3) recommended. PNG, JPG and GIF files
                        are allowed
                      </>
                    )}
                  </span>
                </div>
              </form>
            </div>

            {reelsEditLoader && (
              <div class="form-group col-sm-9">
                <InfinitySpin width="100" color="#FE6B30" />
              </div>
            )}
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">General Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="category-title" class="form-label">
                        Reels Title
                      </label>
                      <input
                        type="text"
                        id="category-title"
                        class="form-control"
                        placeholder="Enter Title"
                        value={values.title || ''}
                        onChange={handleChange}
                        name="title"
                        style={{
                          border: errors.title && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>

                <div class="col-lg-6">
                  <form>
                    <label for="product-categories" class="form-label">
                      Reels Type
                    </label>
                    <select
                      class="form-control"
                      id="product-categories"
                      data-choices
                      data-choices-groups
                      data-placeholder="Select Reels"
                      name="choices-single-groups"
                      value={values.reelsType || ''}
                      onChange={(e) =>
                        setFieldValue('reelsType', e.target.value)
                      }
                      style={{
                        border: errors.reelsType && '1px solid red',
                      }}
                    >
                      <option value="">Choose a Reels Type</option>
                      {reelsTypeStatus?.map((item, key) => (
                        <option key={key} value={item?.name}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                  </form>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="product-id" class="form-label">
                        Link
                      </label>
                      <input
                        type="text"
                        id="link"
                        class="form-control"
                        placeholder="Reels Link"
                        value={values.link || ''}
                        onChange={handleChange}
                        name="link"
                        style={{
                          border: errors.link && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              {/* <div class="col-lg-2">
                <a href="#!" class="btn btn-outline-secondary w-100">
                  Save Change
                </a>
              </div> */}
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {reels_loader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Upload Reels</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Create_Reels;
